import React, { useEffect } from 'react';
const pixelId = '2372875453119137';
type PixelFunction = {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  loaded: boolean;
  version: string;
  push?: unknown;
};
declare global {
  interface Window {
    fbq?: PixelFunction;
    _fbq?: PixelFunction;
  }
}
// Meta Pixel Code — equivalent of the official snippet, deferred until the
// browser is idle so it never competes with first paint.
export function MetaPixel() {
  useEffect(() => {
    if (window.fbq) return;
    const load = () => {
      if (window.fbq) return;
      const fbq = ((...args: unknown[]) => {
        if (fbq.callMethod) fbq.callMethod.apply(fbq, args);else fbq.queue.push(args);
      }) as PixelFunction;
      if (!window._fbq) window._fbq = fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      window.fbq = fbq;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const first = document.getElementsByTagName('script')[0];
      if (first?.parentNode) first.parentNode.insertBefore(script, first);else document.head.appendChild(script);
      fbq('init', pixelId);
      fbq('track', 'PageView');
    };
    const idle = window.requestIdleCallback;
    if (typeof idle === 'function') idle(load, {
      timeout: 2000
    });else window.setTimeout(load, 1200);
  }, []);
  return <noscript data-id="element-85" data-mp="1mfsvgawd0ch8">
      <img alt="" height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`} data-id="element-86" data-mp="1mgb1u0cqk72v" />
    </noscript>;
}